import { isProduction } from 'commons/environment';

const devDomain = () => {
  const { host } = new URL(window.location.href);
  return host.includes('.candu.ai') ? '.candu.ai' : host;
};

export const cookieDomain = () => {
  return isProduction ? '.candu.ai' : devDomain();
};
